<template>
  <div class="recipe_add">
    <br />
    <!--
    <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>药品信息</el-breadcrumb-item>
            <el-breadcrumb-item>修改/查看</el-breadcrumb-item>
        </el-breadcrumb>
    <br />

    <hr />
  -->

    <br />
    <el-main>
      <div class="form-region-header font-30">基本信息</div>
      <el-form ref="form" :model="form" label-width="200px">
        <table>
          <tr>
            <td>
              <el-form-item label="药品名称">
                <el-input v-model="form.name" placeholder="请输入药品名称" clearable></el-input>
              </el-form-item>
              
            </td>
            <td>
              <div class="mustneed">  * 必填 </div>

            </td>
          </tr>
          <tr>
            <td>
              <el-form-item label="规格">
                <el-input v-model="form.specification" placeholder="药品规格如：2板*12片" clearable></el-input>
              </el-form-item>
            </td>
            <td>
              <div class="mustneed">  * 必填 </div>

            </td>
          </tr>
          <tr>
            <td>
              <el-form-item label="单价">
                <el-input v-model="form.price" type="number"></el-input>
              </el-form-item>
            </td>
            <td>
              <div class="postfix">  (元) </div>
            </td>
          </tr>
          <tr>
            <td>
              <el-form-item label="包装盒宽度(mm)">
                <el-input v-model="form.packagewidth" type="number"></el-input>
              </el-form-item>
            </td> 
          </tr>
          <tr>
            <td>
              <el-form-item label="包装盒长度(mm)">
                <el-input v-model="form.packagelength" type="number"></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td>
              <el-form-item label="药品条形码号">
                <el-input v-model="form.code" clearable></el-input>
              </el-form-item>
            </td>
          </tr>
        </table>
      </el-form>
    </el-main>
    <el-footer>
      <el-button type="primary" @click="onSubmit('form')">提交</el-button>
      <el-button @click="goback('form')">返回</el-button>
    </el-footer>
    <!--
        </el-container>
      </el-tab-pane>
    </el-tabs>
    -->
  </div>
</template>

<script>
import qs from "qs";
export default {
  name: "drugAdd",
  data() {
    return {
      activeName: "first",
      addDrugAPI: "http://121.196.220.228:30002/requestAddDrug",
      form: {
        name: "",
        specification: "",
        price: "",
        packageUnit: "",
        packagewidth: "",
        packagelength: "",
        code: "",
        company: ""
      },
        packageUnitOptions: [
          {'label': '盒', 'value': '盒'},
            {'label': '瓶', 'value': '瓶'},
            {'label': '包', 'value': '包'},
            {'label': '袋', 'value': '袋'},
            {'label': '支', 'value': '支'},
            {'label': '板', 'value': '板'},
            {'label': '罐', 'value': '罐'},
            {'label': '台', 'value': '台'},
            {'label': '付', 'value': '付'},
            {'label': '桶', 'value': '桶'},
            {'label': 'g', 'value': 'g'},
            {'label': '碗', 'value': '碗'},
            {'label': '只', 'value': '只'},
            {'label': '瓶/粒', 'value': '瓶/粒'},
            {'label': '对', 'value': '对'},
            {'label': '片', 'value': '片'},
            {'label': '贴', 'value': '贴'}
        ],
      rules: {
      }
    };
  },
  props: {
    msg: String
  },
  methods: {
    goback(formname) {
      // 点击返回按钮，向后跳转
      this.$router.replace("/AddDrug");
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    onSubmit(formName) {
      if (this.form.name.trim() == ""){
        alert("药品名称必须填写");
      }else if(this.form.specification.trim()==""){
        alert("药品规格必须填写");
      }else{
      let datas = {
        authToken: sessionStorage.getItem("authToken"),
        drugName: this.form.name.trim(),
        specification: this.form.specification.trim(),
        price: this.form.price,
        box_width: this.form.packagewidth,
        box_hight: this.form.packagelength,
        drug_bar_code: this.form.code.trim()
      };

      console.log(datas);
        this.$confirm("是否确认添加药品?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
            this.axios.post(this.addDrugAPI, qs.stringify(datas)).then(response => {
              let res = response.data;
              console.log(res);
              if (res.data.result == "success") {
                   alert("药品添加成功");
              } else if (res.data.result == "fail") {
                  alert("添加药品失败!"+ res.data.err.errno);
              }
            });
          }).catch((e) => { });
      }
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  },
  mounted() {
    if (sessionStorage.getItem("authToken") == null||sessionStorage.getItem("authToken").trim()==""){
      this.$router.replace("/Login");
    }
  }
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.mustneed{
  color: red;
  text-align: center;
  margin-top:-20px;
  margin-left:10px;

}

.postfix{
  text-align: center;
  margin-top:-20px;
  margin-left:10px;

}

</style>
